import { useState, useEffect } from "react";
import { useBreakpointValue } from "@chakra-ui/react";

type ButtonPosition = "fixed" | "relative" | "static";

export const useButtonPosition = (screenSizeLimit: number): ButtonPosition => {
	const isMobile = useBreakpointValue({ base: true, md: false });
	const [buttonPosition, setButtonPosition] = useState<ButtonPosition>("static");

	const updateButtonPosition = (): void => {
		const newPosition = isMobile
			? window.innerHeight <= screenSizeLimit
				? "relative"
				: "fixed"
			: "static";

		setButtonPosition(newPosition);
	};

	useEffect(() => {
		updateButtonPosition();

		window.addEventListener("resize", updateButtonPosition);

		return () => {
			window.removeEventListener("resize", updateButtonPosition);
		};
	}, [screenSizeLimit]);

	return buttonPosition;
};
